import { render } from "./Aggregation.vue?vue&type=template&id=bad14020"
import script from "./Aggregation.vue?vue&type=script&lang=js"
export * from "./Aggregation.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__